// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "9cc4fe1c16b0f0ed4d8f" + ".chunk.js";
};